import React from 'react';
import { Link } from 'react-router-dom';
function Howwork() {
  return (
    <>
  <div className="work10">
    <div className="container">
        <div className="row">
            <div className="col-lg-5 m-auto">
                <div className="heading10 text-center space-margin60">
                     <h5 className="vl-section-subtitle aos-init"  data-aos-duration="900"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M9.45001 17.8772C14.2115 17.6442 18 13.7338 18 8.94408C18 7.4743 17.6433 6.08732 17.0111 4.86399C14.4764 6.3183 13.2091 7.04546 12.2507 8.02546C11.1061 9.19582 10.2724 10.6308 9.82481 12.201C9.45001 13.5159 9.45001 14.9697 9.45001 17.8772Z" fill="#02111A"></path>
                    <path d="M8.55001 17.8772C3.78851 17.6442 0 13.7338 0 8.94408C0 7.47429 0.356744 6.08731 0.988876 4.86398C3.52358 6.3183 4.79093 7.04546 5.74937 8.02547C6.89397 9.19583 7.72761 10.6308 8.17521 12.2011C8.55001 13.5159 8.55001 14.9697 8.55001 17.8772Z" fill="#02111A"></path>
                    <path d="M1.43959 4.08981C3.97405 5.54399 5.24127 6.27107 6.57492 6.60594C8.16664 7.00559 9.83338 7.00559 11.4251 6.60594C12.7587 6.27108 14.026 5.54399 16.5604 4.08982C14.9571 1.62862 12.1699 0 9 0C5.8301 0 3.04295 1.62862 1.43959 4.08981Z" fill="#02111A"></path>
                    </svg> How We Work</h5>
                    <div className="space16"></div>
                    <h2 className="vl-section-title aos-init"  data-aos-duration="1000">Our Process Simple <br className="d-lg-block d-none"/> and Effective</h2>
                </div>
            </div>
        </div>
        
        <div className="row">
            <div className="col-lg-6">
                <div className="works-main-widget-area aos-init"  data-aos-duration="900">
                    <div className="text-end">
                        <div className="icons">
                        <img src="assets/img/icons/w-icons8.svg" alt="Our team creates a personalized approach to match the right talent with the right opportunity"/>
                    </div>
                    </div>
                    <div className="space70 d-lg-block d-none"></div>
                    <div className="space30 d-lg-none d-block"></div>
                    <div className="works8-boxarea">
                        <Link to="#" title='Professional recruitment solutions for businesses
'>Tailored Strategy</Link>
                        <div className="space16"></div>
                        <p>Our team creates a personalized approach to match the right talent with the right opportunity.</p>
                        <h5>02</h5>
                    </div>
                </div>
                <div className="works-main-widget-area aos-init"  data-aos-duration="1000">
                    <div className="space70 d-lg-block d-none"></div>
                    <div className="space30 d-lg-none d-block"></div>
                    <div className="text-end">
                        <div className="icons">
                        <img src="assets/img/icons/w-icons10.svg" title='Professional recruitment solutions for businesses
' alt="Our team creates a personalized approach to match the right talent with the right opportunity"/>
                    </div>
                    </div>
                    <div className="space70 d-lg-block d-none"></div>
                    <div className="space30 d-lg-none d-block"></div>
                    <div className="works8-boxarea">
                        <Link to="#" title='Professional recruitment solutions for businesses
'>Ongoing Support</Link>
                        <div className="space16"></div>
                        <p>Our partnership doesn’t end at placement—we’re here to provide continuous support for long-term success.</p>
                        <h5>04</h5>
                    </div>
                </div>
            </div>

             <div className="col-lg-6">
              <div className="space30 d-lg-none d-block"></div>
                <div className="works-main-widget-area2">
                    <div className="works8-boxarea aos-init"  data-aos-duration="1100">
                        <Link to="#" title='Professional recruitment solutions for businesses
'>Tailored Strategy</Link>
                        <div className="space16"></div>
                        <p>Our team creates a personalized approach to match the right talent with the right opportunity.</p>
                        <h5>01</h5>
                    </div>
                    <div className="space70 d-lg-block d-none"></div>
                    <div className="space30 d-lg-none d-block"></div>
                    <div className="text-start">
                        <div className="icons">
                        <img src="assets/img/icons/w-icons8.svg" alt="Our team creates a personalized approach to match the right talent with the right opportunity"/>
                    </div>
                    </div>
                    <div className="space70 d-lg-block d-none"></div>
                    <div className="space30 d-lg-none d-block"></div>
                </div>

                <div className="works-main-widget-area2 aos-init"  data-aos-duration="1200"> 
                    <div className="works8-boxarea">
                        <Link to="#">Ongoing Support</Link>
                        <div className="space16"></div>
                        <p>Our partnership doesn’t end at placement—we’re here to provide continuous support for long-term success.</p>
                        <h5>03</h5>
                    </div>
                    <div className="space70 d-lg-block d-none"></div>
                    <div className="space30 d-lg-none d-block"></div>
                    <div className="text-start">
                        <div className="icons">
                        <img src="assets/img/icons/w-icons10.svg" title='Employee performance management programs
' alt=""/>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</>
  )
}

export default Howwork;
